<template>
    <div>
        <div class="seachHeader ">
            <Navigation :route="navigationRoute"></Navigation>
            <el-input placeholder="题干关键字搜索" v-model="query.keyword" class="input-with-select" size="mini" clearable>
                <i class="el-icon-search el-input__icon" slot="prefix">
                </i>
                <el-button slot="append" type="danger" size="mini" @click="getList(1)">搜索</el-button>
            </el-input>
        </div>
        <div>
            <div class="paper-item" v-for="(e, i) in tableData.records" :key="i">
                <div class="flex-1">
                    <div class="title fontSize14">
                        <span>{{ i + 1 }}、</span>
                        <span class="">【{{ e.type | f('quesMap') }}】</span>
                        <span v-html="reformHtml(e.content)"></span>
                    </div>
                    <div v-if="e.dataJson && e.dataJson.options">
                        <div v-for="(item, index) in e.dataJson.options" :key="index" class="li">
                            <div class="txt">{{ item.alisa }}、<span v-html="reformHtml(item.text)"></span></div>
                        </div>
                    </div>
                    <!-- 解析 -->
                    <div class="analysisBox" >
                        <div>您的答案：
                            <span class="cRed" v-if="e.type=='JUDGMENT'">
                                <span v-if="e.studentAnswer=='Y'">正确</span>
                                <span v-if="e.studentAnswer=='N'">错误</span>
                            </span>
                            <span class="cRed" v-else>{{ e.studentAnswer }}</span>
                        </div>
                        <div class="bzda">正确答案：
                            <span class="cGreed" v-if="e.type=='JUDGMENT'">
                                <span v-if="e.answer=='Y'">正确</span>
                                <span v-if="e.answer=='N'">错误</span>
                            </span>
                            <span class="cGreed" v-else>{{ e.answer }}</span>
                        </div>
                        <div class="stjx">试题解析：<span class="cGrey" v-html="reformHtml(e.analysis)"></span></div>
                    </div>
                </div>
                <div>
                    <el-button style="padding: 6px 0;" @click="del(e.id)" class="cRed" type="text" icon="el-icon-delete" >删除</el-button>
                </div>
            </div>
        </div>
        <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
            :page-size="10" layout="prev, pager, next, jumper" :total="tableData.total">
        </el-pagination>
    </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import choice from "@/components/question/choice.vue";
import { mapState, mapMutations } from "vuex";
import { ctList, ctDelete } from "@/api/myTest.js";
export default {
    name: "",
    components: {
        Navigation,
        choice,

    },
    data() {
        return {
            navigationRoute: [
                { name: '我的测试' },
                { name: '我的错题' },
            ],
            query: {
                current: 1,
                size: 10,
                keyword: ''
            },
            tableData: { //表格数据
                total: 0,
                records: []
            }
        };
    },
    created() {
        this.getList()

    },
    computed: {

    },
    methods: {
        handleCurrentChange(val) {
            this.query.current = val
            this.getList()
        },
        getList(pageNumber, pageSize) {
            // this.tableData = {
            //     "total": 18,
            //     "size": 15,
            //     "pages": 2,
            //     "current": 1,
            //     "records": [
            //         {
            //             "realType": "单选题",
            //             "resolve": null,
            //             "creatorId": "77394E3582D347A4A1963BB698FFA08C",
            //             "wrongFoundBy": null,
            //             "studentAnswer": "D",
            //             "source": "Word",
            //             "type": "SINGLECHOICE",
            //             "content": "<p style=\"\"><span style=\"font-family:Calibri;\">假定某人决定连续5年于每年末存入银行1000元,年利率10%。已知</span><img src=\"http://jxjy-att.whxunw.com/guotu_att/upload/word/20230504/F1286F171B5349B89DB4D427E5C47DCF.png\" align=\"middle\" style=\"vertical-align:middle;border-width:0px;width:1.9473333333333334cm;height:0.7831666666666667cm;\"><img src=\"http://jxjy-att.whxunw.com/guotu_att/upload/word/20230504/5538EA5B8F1244029B0DE91B263F4690.png\" align=\"middle\" style=\"vertical-align:middle;border-width:0px;width:4.5085cm;height:0.6138333333333333cm;\"><span style=\"font-family:Calibri;\">,则其于第5年末一次性可取出年金终值是</span></p>",
            //             "correctedTime": "2023-05-04 15:34:42",
            //             "errorTime": "2025-04-29 17:12:09",
            //             "dbId": "f3a74b9e-8b69-4967-bdf4-5e1097e509cc",
            //             "id": "19608795-0e88-44da-8e15-d02fc0a33826",
            //             "isCorrected": "ZQST",
            //             "correctedBy": "77394E3582D347A4A1963BB698FFA08C",
            //             "seqNum": null,
            //             "wrongReason": null,
            //             "dataJson": {
            //                 "score": 0,
            //                 "answer": "C",
            //                 "resolve": "",
            //                 "options": [
            //                     {
            //                         "alisa": "A",
            //                         "text": "<p style=\"\"><span style=\"font-family:Calibri;\">5163.80元</span></p>"
            //                     },
            //                     {
            //                         "alisa": "B",
            //                         "text": "<p style=\"\"><span style=\"font-family:Calibri;\">5610.56元</span></p>"
            //                     },
            //                     {
            //                         "alisa": "C",
            //                         "text": "<p style=\"\"><span style=\"font-family:Calibri;\">6105.1元</span></p>"
            //                     },
            //                     {
            //                         "alisa": "D",
            //                         "text": "<p style=\"\"><span style=\"font-family:Calibri;\">&nbsp;6620.9元</span></p>"
            //                     }
            //                 ],
            //                 "id": "19608795-0e88-44da-8e15-d02fc0a33826",
            //                 "type": "SINGLECHOICE",
            //                 "content": "<p style=\"\"><span style=\"font-family:Calibri;\">假定某人决定连续5年于每年末存入银行1000元,年利率10%。已知</span><img src=\"http://jxjy-att.whxunw.com/guotu_att/upload/word/20230504/F1286F171B5349B89DB4D427E5C47DCF.png\" align=\"middle\" style=\"vertical-align:middle;border-width:0px;width:1.9473333333333334cm;height:0.7831666666666667cm;\"><img src=\"http://jxjy-att.whxunw.com/guotu_att/upload/word/20230504/5538EA5B8F1244029B0DE91B263F4690.png\" align=\"middle\" style=\"vertical-align:middle;border-width:0px;width:4.5085cm;height:0.6138333333333333cm;\"><span style=\"font-family:Calibri;\">,则其于第5年末一次性可取出年金终值是</span></p>"
            //             },
            //             "difficulty": "CG",
            //             "answer": "C",
            //             "wrongFoundTime": null,
            //             "status": "OK"
            //         }
            //     ]
            // }
                this.query.current = pageNumber || this.query.current
                this.query.size = pageSize || this.query.size
                ctList(this.query).then(res => {
                    this.tableData = res
                })
        },
        reformHtml(html) {
            if (!html) {
                return html
            }
            var reg = new RegExp("\\[BlankArea\\d]", "g");
            html = html.replace(reg, "____");
            return html.replace(/<p.*?>/gi, "").replace(/<\/p.*?>/gi, "");
        },
        del(id){
            ctDelete({id}).then(res => {
                this.$message({
                    showClose: true,
                    message: `操作成功`,
                    type: "success",
                });
                this.getList()
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.seachHeader {
    display: flex;
    justify-content: space-between;

    .input-with-select {
        width: 200px;

        &:deep .el-input-group__append button.el-button--danger {
            color: #FFF;
            background-color: #F56C6C;
            border-color: #F56C6C;
            border-top: inherit;
        }
    }
}

.paper-item {
    margin-top: 20px;
    background: #FFF9F2;
    border-radius: 5px 5px 5px 5px;
    padding: 10px 20px;
    font-weight: 400;
    font-size: 14px;
    color: #767676;
    display: flex;

    .title {
        margin-bottom: 8px;
        font-weight: 400;
        font-size: 16px;
        color: #1A1A1A;
    }

    .li {
        position: relative;
        box-sizing: border-box;
        line-height: 20px;
        // margin: 15px 0;
        margin-bottom: 8px;
        cursor: pointer;
        border-radius: 5px;



        .txt {
            width: 100%;
            word-break: break-all;
            font-size: 14px;
        }
    }
    .analysisBox {
      font-weight: 400;
      font-size: 14px;
      color: #333333;

      div {
        margin: 10px 0;
      }

      .stjx {
        display: flex;

        span {
          width: 420px;
          display: inline-block;
        }
      }

      .stjx-title {
        text-align: center;
        border-top: 1px solid #D2D2D2;
        font-size: 14px;
        color: #E03019;
      }
    }
}
</style>